"use strict";

exports.__esModule = true;
exports.TicketTypeSelector = TicketTypeSelector;
var _react = _interopRequireDefault(require("react"));
var _polished = require("polished");
var _Core = require("../../Core");
var _TicketTypeListContext = require("../TicketTypeListContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function getKey(input) {
  return input.id;
}
function renderItemText(input) {
  return input.value;
}
function TicketTypeSelector(props) {
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  var selectorWithItems = function selectorWithItems(items) {
    return /*#__PURE__*/_react["default"].createElement(_Core.Selector, _extends({
      placeholder: props.multiple ? translate("TicketTypeselector.placeholder.multiple", "Select Types") : translate("TicketTypeselector.placeholder.single", "Select Type"),
      getKey: getKey,
      renderItemText: renderItemText,
      getTagProps: function getTagProps(label, index) {
        var _props$selected = props.selected,
          selected = _props$selected === void 0 ? [] : _props$selected;
        var item = items.find(function (item) {
          return item.id === selected[index];
        });
        if (item == null) {
          return {};
        }
        var backgroundColor = item.color;
        var color = (0, _polished.readableColor)(backgroundColor);
        var style = {
          color: color,
          backgroundColor: backgroundColor
        };
        return {
          style: style
        };
      }
    }, props, {
      items: items
    }));
  };
  if (props.items) {
    return selectorWithItems(props.items);
  }
  return /*#__PURE__*/_react["default"].createElement(_TicketTypeListContext.TicketTypeLoader, null, function (_ref) {
    var fetching = _ref.fetching,
      data = _ref.data;
    if (fetching || !data) return /*#__PURE__*/_react["default"].createElement(_Core.Spinner, null);
    return selectorWithItems(data.filter(function (item) {
      return item.enabled;
    }));
  });
}